const initialValues = {
  activity_name: '',
  status: 'active',
  order: 0,
};
export default initialValues;
